<script>
import ReportingApi from "@/services/reporting-api";
import CustomersApi from "@/services/customers-api";
import ItemsApi from "@/services/items-api";
import UsersApi from "@/services/users-api";

export default {
    
    data(){
        return{
            

            claimsList: [],
            fields: [
                { key:"timestamp", label: "Date"},
                { key:"customer", label: "Client"},
                { key:"username", label: "Utilisateur"},
                { key:"claimType", label: "Type"},
                { key:"itemRef", label: "Référence"},
                { key:"refType", label: "Type Réf"},
                { key:"details", label: "Détails", thStyle:"width:111px; align-middle", tdClass:"align-middle"},
                { key:"isClosed", label: "Etat"},
                
                ],
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            customersList:[],
            usersList:[],
            selectedCustomer:null,
            selectedUser:null,
            start: null, //this.firstDay,
            end: null, //this.lastDay,
            isGetClaimsStarting:false,
            selectedItem: null,

            showDetailsModal : false,
            optionsClaimType: [],
            selectedClaimType: null,
            onlyOpenClaims: null,

            selectedRefType:null,
            refTypeOptions: [{id: 1, name: 'Origine' }, { id: 2, name: 'Adaptable' }]


        }
    },
    methods:{
       
       getClaims(){

            this.isGetClaimsStarting=true
            ReportingApi.getClaims(this.pagemodel.currentPage,
                                    this.pagemodel.perPage,
                                    this.start,
                                    this.end,
                                    this.selectedCustomer==null ? null : this.selectedCustomer.id,
                                    this.selectedClaimType == null ? null : this.selectedClaimType.id,
                                    this.onlyOpenClaims ? true : null,
                                    this.selectedUser != null ? this.selectedUser.id : null,
                                    this.selectedRefType == null ? null : this.selectedRefType.id
        ).then(
                (result) => {
                    if(result){
                        this.claimsList=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isGetClaimsStarting=false
            })
        },
        getCustomers(){
        CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
        },

        getUsers(){
            this.usersList = [];
            this.selectedUser = null;
            if (!this.selectedCustomer) {
                this.usersList = [];
                return;
            }

            UsersApi.getUserInfo(this.selectedCustomer.id).then(
            result => {
                this.usersList = result;
            })
        },

        showDetails(item) {
            this.selectedItem = item;
            this.showDetailsModal = true;
        },

        getClaimTypes() {
            ItemsApi.getClaimTypes()
            .then(claimTypes => {
                this.optionsClaimType = claimTypes;
                this.optionsClaimType.push({"id":-1,"extId":null,"name":"Référence Introuvable","hash":"","relationType":""})
            })
        },

        toggleClaimStatus(item) {

            if (item == null) {
                return;
            }

            ReportingApi.setClaimIsClosed(item.id, !item.isClosed).then(
                () => {
                    ReportingApi.getClaims(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id, this.selectedClaimType == null ? null : this.selectedClaimType.id,
                    this.onlyOpenClaims ? true : null,  this.selectedUser != null ? this.selectedUser.id : null).then(
                        (result) => {
                            if(result){
                                this.claimsList=result.list;
                                this.pagemodel.totalRows = result.total;
                                this.pagemodel.currentPage = result.page;
                                this.pagemodel.perPage = result.pageSize;
                                this.pagemodel.pageSize = result.pageSize;
                            }
                        }
                    )
                }
            ) 
        },

        refTypeToLabel(refType) {
            switch (Number(refType)) {
            case 1:
                return 'origine';
            case 2:
                return 'adaptable';
            case 3:
                return 'ignorer';
            default:
                return 'unknown';
            }
        },

        refTypeToColor(refType) {
            switch (Number(refType)) {
            case 1:
                return 'success';
            case 2:
                return 'warning';
            case 3:
                return 'secondary';
            default:
                return 'light';
            }
        }

    },
    mounted(){
      this.getCustomers()
      this.getClaims()

      this.getClaimTypes();
    },

    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getClaims()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getClaims()
          }
        },

        selectedCustomer: function(){
            this.getUsers();
            this.getClaims()
        },

        selectedUser: function(){
            this.getClaims()
        },

        selectedClaimType: function(){
            this.getClaims()
        },

        onlyOpenClaims: function(){
            this.getClaims()
        },

        selectedRefType: function(){
            this.getClaims()
        },

        
    }

}
</script>
<template>
   
   <div class="clearfix m-4">
        
        <div class="row">

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2 text-left">

                    <h4 class="card-title mb-4 font-size-18 font-weight-bold text-primary">Réclamations des Clients</h4>

            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 text-right">
                    <b-form-checkbox v-model="onlyOpenClaims" switch class="mb-1 float-md-right">
                <label :class="onlyOpenClaims ? 'text-primary' : 'text-muted'">Réclamations ouvertes</label>
                </b-form-checkbox>
            </div>

        </div>
       
        <div  class="row mt-4">
            <div  class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>

            <div  class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
                <b-form-group label="Utilisateurs" label-for="">
                    <v-select class="style-vselect" style="font-size:1.2em;" :options="usersList" :placeholder="$t('lists.customers.label')" label="name" v-model="selectedUser">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>

            <!-- <div  class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div> -->

            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"   label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12   ">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>

        <div  class="row mt-0">
            <!-- <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div> -->

            <!-- <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 "></div> -->

            

            <div  class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-xs-12 ">
            <b-form-group class="mr-2" >

                <v-select class="pb-2 font-size-16" :options="optionsClaimType" v-model="selectedClaimType" placeholder="Toutes les catégories de réclamation" label="name" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 

                <!-- <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" placeholder="Types de réclamations" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select> -->
            </b-form-group>
            </div>
            <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 ">
            <b-form-group class="ml-2">

                <v-select class="pb-2 font-size-16" :options="refTypeOptions" v-model="selectedRefType" placeholder="Tous les types de référence" label="name" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 

                <!-- <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" placeholder="Types de réclamations" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select> -->
            </b-form-group>
            </div>

        </div>

        <div class="table-responsive mb-0" style="max-height:33em;min-height:33em"  >
            <b-table
            :busy="isGetClaimsStarting"
            :striped="true"
            :small="true"
            :hover="true"
            :items="claimsList"
            :fields="fields"
            :perPage="pagemodel.perPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
            </template>


            <template v-slot:cell(timestamp)="{item,value}">
                <span :class="item.isClosed ? 'text-muted' : ' font-weight-bold'">{{value}}</span>
            </template>

            <template v-slot:cell(customer)="{item,value}">
                <span :class="item.isClosed ? 'text-muted' : 'font-weight-bold'">{{value ? value : '-'}}</span>
            </template>

            <template v-slot:cell(username)="{item,value}">
                <span :class="item.isClosed ? 'text-muted' : 'font-weight-bold'">{{value}}</span>
            </template>

            <template v-slot:cell(itemRef)="{ item }">
            <div class="d-flex flex-column">
                <div>
                <span
                    :class="item.isClosed ? 'text-muted' : 'font-weight-bold text-dark'"
                >
                    {{ item.itemRef }}
                </span>
                </div>

                <small v-if="item.brandName" class="text-muted">
                <i class="fas fa-industry mr-1"></i>
                {{ item.brandName }}
                </small>
            </div>
            </template>

            <template v-slot:cell(refType)="{ item }">
                <b-badge v-if="item.refType"
                    pill
                    :variant="refTypeToColor(item.refType)"
                    class="px-3 py-1"
                >
                    {{ $t("reporting.customer.claims." + refTypeToLabel(item.refType)) }}
                </b-badge>
            </template>

            <template v-slot:cell(claimType)="{item, value}">
                <h5>
                    <b-badge href="#" :variant="item.isClosed ? 'light' : !value ? 'info' : 'danger'">
                         {{!value ? 'Référence introuvable' : value}}</b-badge>
                </h5>
            </template>

            <template v-slot:cell(details)="{item,value}"> 
                <!-- <b-button v-if="value" title="Ouvrir"  size="sm"   variant="outline-warning" > -->
                        <i v-if="value" @click="showDetails(item)" style="cursor:pointer;"  class="mdi mdi-comment-text-multiple-outline text-warning text-right font-size-18 align-right"></i>
                        <!-- <span class="d-none font-weight-bold d-sm-inline">Détails</span> -->
                <!-- </b-button>  -->

            </template>

            <template v-slot:cell(isClosed)="{item,value}"> 
                <i  @click="toggleClaimStatus(item)" style="cursor:pointer;" :class="value ? 'far fa-check-square text-muted'  : 'far fa-square text-warning' " class=" text-right font-size-18 align-right"></i>
            </template>

            <!-- <template v-slot:cell(filter)="{value}">
                {{!value ? "_" : value}}
            </template> -->
            
            </b-table>
            <span v-if="!isGetClaimsStarting && !claimsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }}</span>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getClaims()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getClaims()" :disabled="isGetClaimsStarting" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->


            <b-modal v-if="selectedItem"
                v-model="showDetailsModal"
                :title="' [' + selectedItem.itemRef + ']'"
                centered 
                hide-footer
                title-class="text-primary"
                title-tag="h5"
                hide-header
                header-close-variant="danger"
                size="md">
                
                

                <span class="text-warning font-weight-bold">Réclamation [{{selectedItem.itemRef}}] </span>
                <br/><span class="text-muted ">{{selectedItem.username}} {{selectedItem.customer ? ' - ' + selectedItem.customer : ''}}  </span>
                
                <textarea
                    v-model="selectedItem.details"
                    class="form-control mt-3"
                    :maxlength="250"
                    rows="3"
                    disabled
                    ></textarea>

            </b-modal>

    </div>
</template>